<template>
  <div id="app"><router-view v-if="initFinished"></router-view></div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import { setStorage, getStorage } from '@/utils/storageUtils.js';

import { authRefreshToken } from '@/servers/user.js';

export default {
  name: 'App',

  computed: {
    ...mapState(['UI', 'User']),
  },

  data() {
    return {
      initFinished: false,
      refreshInterval: 0,
    };
  },

  created() {
    let that = this;
    this.refresh();
    // 每1.5小时更新一次
    this.refreshInterval = setInterval(function() {
      that.refresh();
    }, 90 * 60 * 1000);
    this.initUI();
  },

  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },

  methods: {
    ...mapMutations(['getUserState']),

    refresh: function() {
      // 直接使用refresh token去刷新token，刷新失败，则清除之前的token状态，this.User.hasLogin = false
      let refreshToken = getStorage('refreshToken');
      let that = this;
      if (refreshToken) {
        authRefreshToken(
          refreshToken,
          function(res) {
            setStorage('token', res.token);
            that.User.hasLogin = true;
            that.initFinished = true;
            that.getUserState();
          },
          function() {
            that.User.hasLogin = false;
            that.initFinished = true;
            setStorage('token', '');
          },
        );
      } else {
        that.User.hasLogin = false;
        that.initFinished = true;
        setStorage('token', '');
      }
    },

    initUI: function() {
      let that = this;
      this.UI.clientHeight = document.documentElement.clientHeight;
      this.UI.clientWidth = document.documentElement.clientWidth;
      if (this.UI.clientWidth <= 600) {
        this.UI.isMobile = true;
      }
      if (this.UI.clientWidth > 2000) {
        this.UI.isGreat2K = true;
      }

      window.onresize = () => {
        return (() => {
          that.UI.clientHeight = document.documentElement.clientHeight;
          that.UI.clientWidth = document.documentElement.clientWidth;
          if (that.UI.clientWidth < that.UI.clientHeight) {
            that.UI.isMobile = true;
          }
          if (that.UI.clientWidth > 2000) {
            that.UI.isGreat2K = true;
          }
        })();
      };
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/consts.scss';
@import '@/assets/style.scss';
@import '@/assets/elCustom.scss';
@import '@/assets/elMobile.scss';
@import '@/assets/custom.scss';
@import '@/assets/number.scss';

body {
  margin: 0;
  padding: 0;
}

div {
  display: block;
}

*::-webkit-scrollbar {
  width: 7px;
  height: 10px;
  background-color: transparent;
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

// *::-webkit-scrollbar-track {
//   background-color: #f0f6ff;
// }

/*定义滚动条轨道 内阴影+圆角*/

*::-webkit-scrollbar-thumb {
  background-color: #73abb1;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue